import printConfig from '../../../print-config.json'
import { FLYER, WEEKPROGRAMFLYER } from '../../../constants/printType'
import PrintWeekProgramFlyerWeeksContainer from './PrintWeekProgramFlyerWeeksContainer'
import ChooseWeekContainer from './ChooseWeekContainer'
import { generatePath } from 'react-router-dom'

const ChoosePrintWeekContainer = ({match, goBackPath, altGoBackPath}) => {
    const { cinemaId, printType, printFormat, landscape, week, printPk } = match.params
    const { formats } = printConfig.routes[printType]
    const backPath = (1 === formats.length && printType !== FLYER) ? altGoBackPath : goBackPath
    const closePagePath = generatePath(backPath, match.params)

    if(WEEKPROGRAMFLYER === printType) {
        return <PrintWeekProgramFlyerWeeksContainer
            cinemaId={cinemaId}
            printType={printType} 
            printID={printFormat}
            landscape={landscape} 
            week={week}
            printPk={printPk}
            closePagePath={closePagePath}
        />
    } else {
        return <ChooseWeekContainer
            cinemaId={cinemaId}
            printType={printType} 
            printID={printFormat}
            landscape={landscape} 
            week={week}
            printPk={printPk}
            closePagePath={closePagePath}
        />
    }
}

export default ChoosePrintWeekContainer